import { useEffect, useState } from 'react';
import Select from 'react-select';
import tools from '../../utils/tools';

const MergeRow = ({
                    product,
                    index,
                    parts,
                    setForm,
                    form,
                    brands
                  }) => {
  const [showMore, setShowMore] = useState(false);
  const [part, setPart] = useState<any>({});

  return (
    <>
      <tr className="dashTr2 borderZero">
        <td className="">
          <Select options={tools.selectFormatter(parts, 'id', 'title', 'انتخاب کنید')} value={tools.selectFormatter(parts.filter(e => e.id == form[product.id]?.partId), 'id', 'title')} className="width100"
                  onChange={(selected) => {
                    setShowMore(true);
                    setPart(parts.find(e => e.id == selected.value));
                    setForm(prev => ({
                      ...prev,
                      [product.id]: {
                        ...prev[product.id],
                        partId: selected.value,
                        slug: product?.url?.split('/')[4]
                      }
                    }));
                  }}
          />
        </td>
        <td className="">
          <Select options={tools.selectFormatter(brands, 'id', 'title', 'انتخاب کنید')} value={tools.selectFormatter(brands.filter(e => form[product.id]?.brands?.includes(e.id)), 'id', 'title')} className="width100"
                  isMulti={true}
                  onChange={(selected) => {
                    setForm(prev => ({
                      ...prev,
                      [product.id]: {
                        ...prev[product.id],
                        brands: selected.map(e => e.value)
                      }
                    }));
                  }}
          />
        </td>
        <td>
          <a href={product.url} target="_blank">{product.url.split('/')[4]}</a>
        </td>
        <td className="">{product?.title}</td>
        <td>
          <img src={product.image} className="width100p"/>
        </td>
        <td>{++index}</td>
      </tr>
      {showMore && part?.specifics?.length > 0 &&
          <tr className="dashTr2">
            {part?.specifics?.map((specific, i) => <td key={product.id + specific.id + i}>
              <label>
                {specific.title}
              </label>
              <Select options={tools.selectFormatter(specific?.specificValues, 'slug', 'title', 'انتخاب کنید')} onChange={(selected) => {
                setForm(prev => {
                  const cp = prev[product.id].specifics || {};
                  if (!cp[specific.slug]) {
                    cp[specific.slug] = {};
                  }

                  cp[specific.slug].value = selected.value;
                  return {
                    ...prev, [product.id]: {...prev[product.id], specifics: cp }
                  };
                });
              }}/>
              <span>
                نمایش در عنوان
              <input type="checkbox" onChange={(input) => setForm(prev => {
                  const cp = prev[product.id].specifics || {};
                  if (!cp[specific.slug]) {
                    cp[specific.slug] = {};
                  }

                  cp[specific.slug].inTitle = input.target.value == "on";

                  return {
                    ...prev, [product.id]: {...prev[product.id], specifics: cp }
                  };
              })}/>
              </span>
            </td>)}
          </tr>
      }
    </>
  );
};
export default MergeRow;
